var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindDir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@1xWind_Direction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wind_Direction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3, 3)",
    fill: "#1991DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,20 L2.66666667,20 L2.66666667,17.3333333 L11.3333333,17.3333333 C13.9106667,17.3333333 16,19.4226667 16,22 C16,24.5773333 13.9106667,26.6666667 11.3333333,26.6666667 C9.33276,26.6666667 7.62621333,25.4078667 6.96261333,23.6390667 L9.46017333,22.7024 C9.74457333,23.4605333 10.4759467,24 11.3333333,24 C12.4378667,24 13.3333333,23.1045333 13.3333333,22 C13.3333333,20.8954667 12.4378667,20 11.3333333,20 Z M4,12 L22,12 C24.5773333,12 26.6666667,14.0893333 26.6666667,16.6666667 C26.6666667,19.244 24.5773333,21.3333333 22,21.3333333 C19.9994667,21.3333333 18.2929333,20.0745333 17.6293333,18.3057333 L20.1268,17.3690667 C20.4112,18.1272 21.1426667,18.6666667 22,18.6666667 C23.1045333,18.6666667 24,17.7712 24,16.6666667 C24,15.5621333 23.1045333,14.6666667 22,14.6666667 L4,14.6666667 C1.79086667,14.6666667 0,12.8758667 0,10.6666667 C0,8.45753333 1.79086667,6.66666667 4,6.66666667 L15.3333333,6.66666667 C16.4378667,6.66666667 17.3333333,5.77124 17.3333333,4.66666667 C17.3333333,3.56209333 16.4378667,2.66666667 15.3333333,2.66666667 C14.476,2.66666667 13.7445333,3.20617333 13.4601333,3.96422667 L10.9626667,3.02764 C11.6262667,1.25885333 13.3328,0 15.3333333,0 C17.9106667,0 20,2.08933333 20,4.66666667 C20,7.244 17.9106667,9.33333333 15.3333333,9.33333333 L4,9.33333333 C3.26362667,9.33333333 2.66666667,9.93029333 2.66666667,10.6666667 C2.66666667,11.4030667 3.26362667,12 4,12 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(9, 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C3.3578625,15 0,11.6421 0,7.5 C0,3.3578625 3.3578625,0 7.5,0 C11.6421,0 15,3.3578625 15,7.5 C15,11.6421 11.6421,15 7.5,15 Z",
    id: "Path",
    fill: "#1991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,13.5 C10.813725,13.5 13.5,10.813725 13.5,7.5 C13.5,4.18629 10.813725,1.5 7.5,1.5 C4.18629,1.5 1.5,4.18629 1.5,7.5 C1.5,10.813725 4.18629,13.5 7.5,13.5 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1991DC",
    points: "3.75 7.125 10.5 4.5 7.875 11.251575 6.75 8.25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDir);
export default __webpack_public_path__ + "static/media/WindDir.7b6275168edbad302f057289dbe5f222.svg";
export { ForwardRef as ReactComponent };